/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TransactionDto } from '../../models/transaction-dto';

export interface AdminControllerGetUserTransactions$Params {
  uuid: string;
}

export function adminControllerGetUserTransactions(http: HttpClient, rootUrl: string, params: AdminControllerGetUserTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TransactionDto>>> {
  const rb = new RequestBuilder(rootUrl, adminControllerGetUserTransactions.PATH, 'get');
  if (params) {
    rb.path('uuid', params.uuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TransactionDto>>;
    })
  );
}

adminControllerGetUserTransactions.PATH = '/admin/user/{uuid}/transactions';
